const state = {
  isShow: false,
};

const getters = {
  isShow(state) {
    return state.isShow;
  },
};

const mutations = {
  START() {
    state.isShow = true;
  },
  EXIT() {
    state.isShow = false;
  },
};

export default {
  namespaced: "CheckIn",
  state,
  mutations,
  getters,
};
